const InfoText = ({message}) => {
  return (
    <div className="text-body text-sm mt-1">
        <i className="fa fa-info-circle text-primary mr-1!"/>
        {message}
    </div>
  )
}

export default InfoText;